import type { SxStyle } from '@aibees/shared/theme';

export const root: SxStyle = {};

export const menuItem: SxStyle = {
  display: 'flex',
  flexDirection: 'row',
  alignItems: 'center',
  borderTopWidth: '1px',
  gap: (p) => p.spacing(1),
  borderTopColor: (p) => p.palette.grey[300],
  borderTopStyle: 'solid',
  border: 'none',
  svg: {
    color: (p) => p.palette.grey[500],
  },
};

export const menuItemInfo: SxStyle = {
  ml: 'auto',
  pl: (p) => p.spacing(1),
  justifyContent: 'center',
};
